import React from "react";
import { 
  Col, 
  Row, 
  Button, 
  Input} from "reactstrap";

import ToolkitProvider, {
  CSVExport
} from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import SubUserStatementUnavailbleTooltip from "./subuserStatementUnavailableTooltip";
import { useTranslation } from "react-i18next";

const SubuserStatementViewOnlyTable = ({ tableData, searchQuery, defaultSorted }) => {  
  const { ExportCSVButton } = CSVExport;
  const { t } = useTranslation();

  const months = [
    t("subuserStatements.viewOnly.table.label.monthJanuary"),
    t("subuserStatements.viewOnly.table.label.monthFebruary"),
    t("subuserStatements.viewOnly.table.label.monthMarch"),
    t("subuserStatements.viewOnly.table.label.monthApril"),
    t("subuserStatements.viewOnly.table.label.monthMay"),
    t("subuserStatements.viewOnly.table.label.monthJune"),
    t("subuserStatements.viewOnly.table.label.monthJuly"),
    t("subuserStatements.viewOnly.table.label.monthAugust"),
    t("subuserStatements.viewOnly.table.label.monthSeptember"),
    t("subuserStatements.viewOnly.table.label.monthOctober"),
    t("subuserStatements.viewOnly.table.label.monthNovember"),
    t("subuserStatements.viewOnly.table.label.monthDecember")
  ];

  const currencies = ["€", "$", "£"];

  const monthFormatter = (cell, row) => {
    cell = months[cell - 1];
    return cell;
  };

  const nameFormatter = (cell, row) => {
    let cellFormatted = cell.replaceAll("Subuser", "User");
    return cellFormatted;
  };

  const amountFormatter = (cell, row) => `${cell}${currencies[row.currency]}`;

  const quartalFormatter = cell =>
    cell === 0
      ? t("subuserStatements.viewOnly.table.label.quarterQ1")
      : cell === 1
      ? t("subuserStatements.viewOnly.table.label.quarterQ2")
      : cell === 2
      ? t("subuserStatements.viewOnly.table.label.quarterQ3")
      : cell === 3
      ? t("subuserStatements.viewOnly.table.label.quarterQ4")
      : null;

  const statusFormatter = cell =>
    cell === 0 ? (
      <Button className="btn-status" disabled color="warning">
        {t("subuserStatements.viewOnly.table.label.statusOpen")}
      </Button>
    ) : cell === 1 ? (
      <Button className="btn-status" disabled color="success">
        {t("subuserStatements.viewOnly.table.label.statusPaid")}
      </Button>
    ) : null;

  const typeFormatter = cell =>
    cell === 1
      ? (cell = t("subuserStatements.viewOnly.table.label.typeLicensing"))
      : cell === 2
      ? t("subuserStatements.viewOnly.table.label.typeRegular")
      : cell === 3
      ? t("subuserStatements.viewOnly.table.label.typeAudioMasteringServices")
      : cell === 4
      ? t("subuserStatements.viewOnly.table.label.typeVinylEarnings")
      : cell === 5
      ? t("subuserStatements.viewOnly.table.label.typeOffset")
      : t("subuserStatements.viewOnly.table.label.typeNotKnown");
    
  const downloadFormatter = (cell, row) =>
    cell ?
    (
      <a href={cell} target="blank">
      <Button className="btn-status" color="primary">
        <b>{t("subuserStatements.viewOnly.table.button.download")}</b>
      </Button>
      </a>
    ) :
      <center>
        <SubUserStatementUnavailbleTooltip id={row.id} />
      </center>;

  const columns = [
    {
      dataField: "name",
      text: t("subuserStatements.viewOnly.table.column.name"),
      formatter: nameFormatter,
      csvFormatter: nameFormatter,
      sort: true
    },
    {
      dataField: "sts_kind",
      text: t("subuserStatements.viewOnly.table.column.type"),
      sort: true,
      formatter: typeFormatter,
      csvFormatter: typeFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "120px" };
      }
    },
    {
      dataField: "quartal",
      text: t("subuserStatements.viewOnly.table.column.quarter"),
      sort: true,
      formatter: quartalFormatter,
      csvFormatter: quartalFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "120px" };
      }
    },
    {
      dataField: "year",
      text: t("subuserStatements.viewOnly.table.column.year"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "120px" };
      }
    },
    {
      dataField: "month",
      text: t("subuserStatements.viewOnly.table.column.month"),
      sort: true,
      formatter: monthFormatter,
      csvFormatter: cell => months[cell - 1],
      headerStyle: (colum, colIndex) => {
        return { width: "120px" };
      }
    },
    {
      dataField: "short_description",
      text: t("subuserStatements.viewOnly.table.column.description")
    },
    {
      dataField: "price",
      text: t("subuserStatements.viewOnly.table.column.amount"),
      sort: true,
      formatter: amountFormatter,
      csvFormatter: amountFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "120px" };
      }
    },
    {
      dataField: "status",
      text: t("subuserStatements.viewOnly.table.column.status"),
      sort: true,
      formatter: statusFormatter,
      csvFormatter: cell =>
        cell === 0 ? "Open" : cell === 1 ? "  Paid" : null,
      headerStyle: (colum, colIndex) => {
        return { width: "120px" };
      }
    },
    {
      dataField: "new_overview",
      text: t("subuserStatements.viewOnly.table.column.overview"),
      formatter: downloadFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "120px" };
      }
    },
    {
    dataField: "new_details",
      text: t("subuserStatements.viewOnly.table.column.details"),
      formatter: downloadFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "120px" };
      }
    },

    //data for search
    {
      dataField: "status",
      sort: false,
      csvExport: false,
      hidden: true,
      formatter: cell => (cell === 0 ? "Open" : cell === 1 ? "Paid" : null)
    }
  ];

  const handleTableChange = (type, { sortField, sortOrder, data }) => {
    const ascDesc = sortOrder === "desc" ? "-" : "";
    if (sortField === "kind" || sortField === "sts_kind" || sortField === "quartal" || sortField === "month" || sortField === "year" || sortField === "price") {
      searchQuery.setOrdering({order: ascDesc, name: sortField, sort: sortField});
    }
    if (sortField === "name") {
      searchQuery.setOrdering({order: ascDesc, name: "id", sort: sortField});
    }
  }


  return (
    <div>
      <ToolkitProvider
        keyField="id"
        data={tableData}
        columns={columns}
        search={{
          searchFormatted: true
        }}
        exportCSV={ {
          fileName: "subuser-statements.csv",
        } }
      >
        {props => (
          <div>
            <Row>
              <Col>
                <div className="customSearch">
                  <Input placeholder={t("subuserStatements.viewOnly.table.placeholder.search")} value={searchQuery.query} style={{marginBottom: 10}} onChange={e => searchQuery.setQuery(e.target.value)}/>
                </div>
              </Col>
              <Col>
                <div className="flexEndContainer">
                                 
                  <ExportCSVButton
                    className="btn btn-outline-info"
                    {...props.csvProps}
                  >
                    {t("subuserStatements.viewOnly.table.button.export_csv")}
                  </ExportCSVButton>
                </div>
              </Col>
            </Row>
            <BootstrapTable
              {...props.baseProps}
              bordered={ false }
              remote={ { sort: true } }
              defaultSorted={defaultSorted}
              onTableChange={handleTableChange}
            />
          </div>
        )}
      </ToolkitProvider>
    </div>
  );
};

export default SubuserStatementViewOnlyTable;
